import type { WheelEvent } from 'react';

/**
 * Turns a vertical wheel into horizontal scrolling for a `chipRow`.
 *
 * Desktop has no touch-drag and the mixin hides the scrollbar, so without this
 * every chip past the fold is unreachable with a mouse. Mobile needs nothing —
 * `touch-action: pan-x` in the mixin already handles the swipe.
 *
 * Shared by Explore's category filters and the chat quick-replies; it was
 * written inline in Explore first, and a second copy is how two chip rows start
 * behaving differently.
 */
export function onHorizontalWheel(event: WheelEvent<HTMLElement>): void {
  if (event.deltaY === 0) return;
  event.currentTarget.scrollLeft += event.deltaY;
  event.preventDefault();
}
